import "../StudentManagement.scss";
// import "../";
import React, { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import useFullPageLoader from "common/UseFullPageLoader";
import { userDetailApi } from "services/user";
import {
  userPlaceholderIcon,
} from "assets/images";
import constant from "../../../constants/constatValue";
import { firstWordCapital, getValueOrFallback } from "utils/common";
import { dateFormatWithTime, formatToDDMMYYYY } from "utils/dateFormat";
import "../UserDetail.css";
import Babies from "../componentabs/Babies";
import FeedBack from "../componentabs/FeedBack";
import Subscription from "../componentabs/Subscription";
import ChangeSelectedUserStatus from "../ChangeSelectedUserStatus";

const { USER_ROLE } = constant;

const SelectedUserDetail = () => {
  const { userId } = useParams();
  const [userStatusModal, setUserStatusModal] = useState(false);
  const [loader, onShow, onHide] = useFullPageLoader();
  const [inputData, setInputData] = useState({});
  const [searchParams, setSearchParams] = useSearchParams({});
  const userRoleValue = searchParams.get("userRole") || "researcher";

  //Handle user role
  const changeUserRoleHandler = (role) => {
    searchParams.set("userRole", role);
    setSearchParams(searchParams);
  };

  // fetch User Deatil
  const fetchSelectedUserDetail = async () => {
    try {
      onShow();
      const { data, status } = await userDetailApi(userId);
      if (status === 200) {
        setInputData(data?.data);
      }
    } catch (e) {
      console.log("error:", e.message);
    } finally {
      onHide();
    }
  };

  useEffect(() => {
    fetchSelectedUserDetail(userId);
  }, []);

  const changeUserStatusHandler = (data) => {
    setUserStatusModal(true)
  }

  const onClose = () => {
    setUserStatusModal(false);
  };

  const [propertyTab, setPropertyTab] = useState("Babies");

  return (
    <>
      {loader}
      <div className="editProfile">
        <div className="breadcrumb">
          <ul>
            <li>
              <Link to={-1}>User Management</Link>
            </li>
            <li>User details</li>
          </ul>

          <div className="user-detail-header">
            <button className="button" onClick={() => changeUserStatusHandler(inputData)}>{ inputData?.status === "ACTIVE" ? "Block" : "UnBlock"} User</button>
          </div>
        </div>

        <div className="personal_details _box spacing">
          {Array.isArray(inputData?.userRole) &&
            inputData?.userRole.length === 2 && (
              <div className="tab_button_wrap">
                <ul>
                  {USER_ROLE.map((role) => (
                    <li key={role}>
                      <button
                        type="button"
                        className={userRoleValue === role ? "active" : ""}
                        onClick={() => changeUserRoleHandler(role)}
                      >
                        {firstWordCapital(role)}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          <div className="personal_details">
            <div className="image_wrap">
              <img
                src={inputData?.profilePicture || userPlaceholderIcon}
                alt="user profile"
              />
            </div>
            <div className="details_list">
              <ul>
                <li>
                  <b>User Name :</b>
                  <span>{getValueOrFallback(inputData?.fullName)}</span>
                </li>

                {/* <li>
                  <b>Mobile Number :</b>
                  <span>
                    {(inputData?.contact?.mobileNumber?.number || "")}
                  </span>
                </li> */}

                <li>
                  <b>Email </b>
                  <span>{inputData?.contact?.email || "N/A"}</span>
                </li>

                <li>
                  <b>Registration Date: </b>
                  <span>{formatToDDMMYYYY(inputData?.createdAt)}</span>
                </li>

                <li>
                  <b>Subscription: </b>
                  <span></span>
                </li>

                <li>
                  <b>Last Login Date: </b>
                  <span>{dateFormatWithTime(inputData?.session?.updatedAt)}</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="wrapper_cstm_tabers">
            <ul>
              <li
                className={propertyTab === "Babies" ? "active" : ""}
                onClick={() => setPropertyTab("Babies")}
              >
                Babies
              </li>

              <li
                className={propertyTab === "Feedbacks" ? "active" : ""}
                onClick={() => setPropertyTab("Feedbacks")}
              >
                Feedbacks
              </li>

              <li
                className={propertyTab === "Subscription" ? "active" : ""}
                onClick={() => setPropertyTab("Subscription")}
              >
                Subscription
              </li>
            </ul>
          </div>

          {propertyTab === "Babies" && <Babies userId={inputData?._id} />}
          {propertyTab === "Feedbacks" && <FeedBack userId={inputData?._id} />}
          {propertyTab === "Subscription" && <Subscription userId={inputData?._id} />
          }
        </div>
      </div>

      {/* Change User Status*/}
      {userStatusModal && (
        <ChangeSelectedUserStatus
          selectedUserDetail={inputData}
          onClose={() => onClose()}
          userStatusModal={userStatusModal}
          refetchUserList={() => fetchSelectedUserDetail(userId)}
        />
      )}
    </>
  );
};
export default SelectedUserDetail;
